import { createReducer } from '@reduxjs/toolkit';
import { filtersInitialState } from './components/filters/utils/definitions';
import { searchActions } from './search.actions';
export const initialState = {
    params: {
        query: '',
        filters: filtersInitialState,
        sort: undefined,
        strict: false,
        page: 1,
    },
};
export const searchReducer = createReducer(initialState, (builder) => builder
    .addCase(searchActions.params.update, (state, action) => {
    var _a;
    Object.assign(state.params, Object.assign(Object.assign({}, action.payload), { filters: Object.assign(state.params.filters, action.payload.filters), page: (_a = action.payload.page) !== null && _a !== void 0 ? _a : 1 }));
})
    .addCase(searchActions.savedSearch.apply, (state, action) => {
    state.savedSearch = action.payload;
    Object.assign(state.params, Object.assign(Object.assign({}, action.payload.params), { page: 1 }));
})
    .addCase(searchActions.savedSearch.close, (state) => {
    state.params = initialState.params;
    delete state.savedSearch;
}));
